var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "activeToggle",
    attrs: {
      id: "active-status-modal",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.words.no"),
      "modal-dialog-size": "md",
    },
    on: { show: _vm.show },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v("\n      " + _vm._s(_vm.modalTitleText) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("client-profile.actions.markClientConfirmation")
                  ) +
                  "\n      " +
                  _vm._s(
                    _vm._f("capitalize")(
                      _vm.activeToggle
                        ? _vm.$t("global.words.inactive")
                        : _vm.$t("global.words.active")
                    )
                  ) +
                  "?\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                ref: "activeToggleButton",
                attrs: {
                  type: _vm.activeToggle ? "danger" : "primary",
                  loading: _vm.loading,
                },
                on: { click: _vm.toggleActiveStatus },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.yes")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }